import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { NOT_FOR_SALE, SOLD, SOLD_OUT } from '../helpers/constants'
import RecommendedArtworksCarousel from 'components/ProductCarousels/RecommendedArtworks'
import ArtistArtworksCarousel from 'components/ProductCarousels/ArtistArtworks'
import VisuallySimilarCarousel from 'components/ProductCarousels/VisuallySimilar'
import { getSelectedProductStatus } from '../selectors/product'

type CarouselsProps = {
  shouldLoadComponent: boolean
  setShouldLoadComponent
}

const Carousels: FC<CarouselsProps> = ({ shouldLoadComponent, setShouldLoadComponent }) => {
  const productStatus = useSelector(getSelectedProductStatus)
  const isProductNotForSale = productStatus === NOT_FOR_SALE
  const isProductNotForSaleOrOrSold = [NOT_FOR_SALE, SOLD, SOLD_OUT].includes(productStatus)

  return (
    <>
      <div data-section='artist-carousel'>
        <ArtistArtworksCarousel setShouldLoadComponent={setShouldLoadComponent} />
      </div>
      <div data-section='rec-carousel' data-style={isProductNotForSale ? 'change-order' : ''}>
        <RecommendedArtworksCarousel
          shouldLoadComponent={isProductNotForSale ? true : shouldLoadComponent}
          setShouldLoadComponent={setShouldLoadComponent}
        />
      </div>
      <div
        data-section='visii-carousel'
        data-style={isProductNotForSaleOrOrSold ? 'change-order' : ''}
      >
        <VisuallySimilarCarousel
          shouldLoadComponent={isProductNotForSaleOrOrSold ? true : shouldLoadComponent}
          setShouldLoadComponent={setShouldLoadComponent}
        />
      </div>
    </>
  )
}

export default Carousels
